module.exports = __webpack_public_path__ + "media/images/emblems/Treiten-coat_of_arms-2af02d2e6dec641671efaf0819e5a1b3.svg";